/*
     * Validate file extension and return true if valid (if not sure, assume it's valid)
     */

export class FileUploadValidation {



    public static validateFileExtension(valid_exts, file) {

        if (file !== undefined && file !== null) //if file is specified (would require HTML5)
        {

            const file_name = file.name;

            if (file_name !== undefined && file_name != null && file_name !== "") //the browser could return an empty value, even if it's a legit upload
            {

                const file_ext = FileUploadValidation.getFileExtension(file_name).toLowerCase();

                if (file_ext !== "") //extension exists
                {

                    let valid_ext = false;

                    for (const i in valid_exts) {

                        if (valid_exts[i].toLowerCase() === file_ext) {
                            valid_ext = true;
                            break;
                        }

                    }
                    return valid_ext;

                } else {
                    return false;
                }
            }
        }
        return false;
    }


    /*
     * Validate file mime-type and return true if valid (if not sure, assume it's valid)
     */

    public static validateFileMimeType(valid_mime_types, file) {

        if (file !== undefined && file !== null) //if file is specified (would require HTML5)
        {

            let file_mime_type = file.type;

            if (file_mime_type !== undefined && file_mime_type !== null && file_mime_type !== "") //the browser could return an empty value, even if it's a legit upload
            {

                file_mime_type = file_mime_type.toLowerCase();

                for (const i in valid_mime_types) {
                    if(valid_mime_types[i].indexOf("/*") !== -1) {
                        if(valid_mime_types[i].toLowerCase().replace("/*", "") === file_mime_type.replace(new RegExp("/.*"), "")) {
                            return true;
                        }
                    }
                    if (valid_mime_types[i].toLowerCase() === file_mime_type) {
                        return true;
                    }

                }
                return false;
            }
        }
        return true; //we can only check the mime-type if the browser has the HTML5 File API, so if that fails, it may be a valid upload for all we know

    }


    /*
     * Validate file size in bytes and return true if valid (if not sure, assume it's valid)
     */

    public static validateFileSize(max_size, file) {

        if (file !== undefined && file !== null) //if file is specified (would require HTML5)
        {

            const file_size = file.size;

            if (file_size !== undefined && file_size != null && file_size !=="" && FileUploadValidation.isInt(file_size)) //the browser could return an empty value, even if it's a legit upload
            {
                return file_size <= max_size;
            }
        }
        return true; //we can only check the file size if the browser has the HTML5 File API, so if that fails, it may be a valid upload for all we know
    }



    private static getFileExtension(filename) {
        const filename_dot_pos = filename.lastIndexOf('.');
        return (filename_dot_pos !== -1) ? filename.substring(filename_dot_pos + 1) : "";
    }

    private static isInt(num)
    {

        if (!isNaN(num))
        {

            if ((parseInt(num)+"")===num)
            {
                return true;
            }

        }

        return false;

    }
}